import { SCRIPT_IMG, ScriptImage } from "@/components/ScriptImage";

export default function RegistryPanel() {
  return (
    <div
      data-testid="panel-block-registry"
      className="max-w-[680px] mx-auto px-2 md:px-0 pb-16"
      style={{ fontFamily: "'Cormorant Garamond', serif" }}
    >
      <div className="text-center pt-2">
        <ScriptImage src={SCRIPT_IMG.registry} alt="Registry" />
      </div>
      <div className="mt-10 space-y-6 text-[15px] md:text-base leading-[1.8] text-[#2C1A1D]/85 text-center">
        <p>
          Your company and effort to travel from all over Australia (and the
          world!) is the greatest gift we could ask for today.
        </p>
        <p>
          However, if you&rsquo;d like to give towards our new life together,
          a wishing well will be present on the day.
        </p>
      </div>
    </div>
  );
}
